import type { UploadPolicy } from "@nexus/contracts";

const EXTENSION_TO_CONTENT_TYPE: Record<string, string> = {
  mp4: "video/mp4",
  mov: "video/quicktime",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  pdf: "application/pdf",
};

/** Browsers sometimes omit `File.type`; infer from extension when the policy allows it. */
export function resolvePartnerPreflightContentType(file: File, policy: UploadPolicy): string {
  const declared = file.type.trim();
  if (declared && policy.allowedContentTypes.includes(declared)) {
    return declared;
  }

  const extension = file.name.split(".").pop()?.toLowerCase();
  if (!extension) return declared;

  const inferred = EXTENSION_TO_CONTENT_TYPE[extension];
  if (inferred && policy.allowedContentTypes.includes(inferred)) {
    return inferred;
  }

  return declared;
}
